import {PlaceholderComponent} from '../shared/placeholder.component';
import {PictureFormComponent} from './picture-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';
import {PictureViewComponent} from './picture-view.component';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'assignment.survey.edit.channel.edit.picture',
    abstract: true,
    component: PlaceholderComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.pageTitle',
      scopes: ['picture:read']
    }
  },
  {
    name: 'assignment.survey.edit.channel.edit.picture.add',
    component: PictureFormComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.pageTitle',
      scopes: ['picture:create']
    }
  },
  {
    name: 'assignment.survey.edit.channel.edit.picture.edit',
    component: PictureFormComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.edit.pageTitle',
      scopes: ['picture:update']
    }
  },
  {
    name: 'assignment.survey.edit.channel.edit.picture.view',
    component: PictureViewComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.view.pageTitle',
      scopes: ['picture:read']
    }
  },
  {
    name: 'assignment.execution.edit.channel.edit.picture',
    abstract: true,
    component: PlaceholderComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.pageTitle',
      scopes: ['picture:read']
    }
  },
  {
    name: 'assignment.execution.edit.channel.edit.picture.add',
    component: PictureFormComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.pageTitle',
      scopes: ['picture:create']
    }
  },
  {
    name: 'assignment.execution.edit.channel.edit.picture.view',
    component: PictureViewComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.view.pageTitle',
      scopes: ['picture:read']
    }
  },
  {
    name: 'assignment.execution.edit.channel.edit.picture.edit',
    component: PictureFormComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.edit.pageTitle',
      scopes: ['picture:update']
    }
  },
  {
    name: 'assignment.maintenance.edit.channel.edit.picture',
    abstract: true,
    component: PlaceholderComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.pageTitle',
      scopes: ['picture:read']
    }
  },
  {
    name: 'assignment.maintenance.edit.channel.edit.picture.add',
    component: PictureFormComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.pageTitle',
      scopes: ['picture:create']
    }
  },

  {
    name: 'assignment.maintenance.edit.channel.edit.picture.view',
    component: PictureViewComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.view.pageTitle',
      scopes: ['picture:read']
    }
  },
  {
    name: 'assignment.maintenance.edit.channel.edit.picture.edit',
    component: PictureFormComponent,
    future: true,
    data: {
      pageTitle: 'states.picture.edit.pageTitle',
      scopes: ['picture:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class PictureRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/picture/picture.routes.ts